<div
  class="k-select"
  [class.k-select--multiple]="multiple()">
  <div class="k-select__wrapper">
    <button
      type="button"
      (click)="toggleOpen()"
      (blur)="onBlur()"
      (keydown)="onKeydown($event)"
      [disabled]="disabled()"
      role="combobox"
      aria-haspopup="listbox"
      [attr.aria-expanded]="isOpen()"
      [attr.aria-disabled]="disabled()"
      [attr.aria-invalid]="isError()"
      [attr.aria-required]="isRequired()"
      [class]="
        'k-select__field ' +
        (isError() ? 'k-select__field--error' : '') +
        (hasSuffixIcon() ? ' k-select__field--has-suffix' : '')
      ">
      <span
        class="k-select__value"
        [class.k-select__value--placeholder]="!selectedLabel()">
        {{ selectedLabel() || displayPlaceholder() }}
      </span>
    </button>

    @if (effectiveIcon()) {
      <span
        class="k-select__suffix-icon material-symbols-outlined"
        [class.k-select__suffix-icon--clickable]="isIconClickable()"
        (click)="onSuffixIconClick($event)">
        {{ effectiveIcon() }}
      </span>
    }

    @if (isOpen()) {
      <div
        class="k-select__panel"
        role="listbox"
        animate.enter="panel-enter"
        animate.leave="panel-leave">
        @if (searchable()) {
          <div
            class="k-select__search"
            (mousedown)="$event.stopPropagation()">
            <div class="k-select__search-wrapper">
              <span class="k-select__search-icon material-symbols-outlined">search</span>
              <input
                #searchInput
                type="text"
                class="k-select__search-input"
                [placeholder]="searchPlaceholder() || 'Hľadať...'"
                (input)="onSearchInput($event)"
                (keydown)="onSearchKeydown($event)"
                autocomplete="off" />
            </div>
          </div>
        }
        <div
          class="k-select__options"
          (mousedown)="$event.preventDefault()">
          @for (option of filteredOptions(); track option.value; let idx = $index) {
            <button
              type="button"
              class="k-select__option"
              role="option"
              tabindex="-1"
              [disabled]="option.disabled"
              [attr.aria-selected]="isOptionSelected(option)"
              [attr.aria-disabled]="option.disabled"
              [class.k-select__option--active]="idx === activeIndex()"
              [class.k-select__option--selected]="isOptionSelected(option)"
              (mousedown)="$event.stopPropagation()"
              (click)="onOptionClick(option); $event.stopPropagation()">
              @if (multiple()) {
                <span
                  class="k-select__checkbox"
                  [class.k-select__checkbox--checked]="isOptionSelected(option)">
                  @if (isOptionSelected(option)) {
                    <span class="material-symbols-outlined">check</span>
                  }
                </span>
              }
              <span class="k-select__option-label">{{ option.label }}</span>
            </button>
          }
          @if (filteredOptions().length === 0) {
            <div class="k-select__no-results">
              {{ 'common.no_results' | translate }}
            </div>
          }
        </div>
      </div>
    }
  </div>

  @if (currentErrorMessage()) {
    <div class="k-select__error">
      {{ currentErrorMessage()! | translate }}
    </div>
  }
</div>
